import Vue from 'vue'
import * as Sentry from '@sentry/vue'
import utils from '@/util'
import cookie from '@/services/cookie'

// api
import AuthApi from '@/api/auth'

export default (component) => Vue.component('SSOFormContainer', {
  data() {
    return {
      error: null,
      isSubmitting: false,
    }
  },
  created() {
    const error = utils.getParamValue('error')
    if (error) this.error = 'default_error'
  },
  methods: {
    async loginWithSSO(email) {
      try {
        this.isSubmitting = true
        const { redirectUrl } = await AuthApi.loginWithSSO({ email })

        this.checkAudienceRedirect()

        setTimeout(() => {
          this.isSubmitting = false
        }, 2000)
        this.$func.go(redirectUrl)
      } catch (error) {
        Sentry.captureException(error)
        this.isSubmitting = false
        this.error = this.$func.getErrorMessage(error, 'default_error')
      }
    },
    checkAudienceRedirect() {
      const { from, redirect } = this.$route.query

      if (from === 'audience' && redirect) {
        cookie.setValue('audience-sso-login-redirect', redirect, {})
      }
    },
  },
  render(createElement) {
    return createElement(component, {
      props: {
        error: this.error,
        loginWithSSO: this.loginWithSSO,
        isSubmitting: this.isSubmitting,
      },
    })
  },
})
